import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateTrainingHelpPriority,
  getTrainingHelps,
} from "../../../../action/masters/trainingHelpActionCreator";
import {
  changePositionOnDrag,
  changeVisibilty,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateTrainingHelpPriority,
  ITrainingHelps,
} from "../../../../models/master/trainingHelp";
import { setApps } from "../../../../store/slices/master/appSlice";
import LoaderSpinner from "../../../../common-components/loader";
import { ConfigUserTypes, UserTypes } from "../../../../models/dashboard/adminDashboard";

const PriorityTrainingHelps = (props: IUpdateTrainingHelpPriority) => {
  const {
    updateTrainingHelpPriority,
    getTraininghelps,
    trainingHelps,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();
  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateTrainingHelpPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    setLoader(true);
    let _items = changeVisibilty(id, _displayOrNot, filteredItems);
    setfilteredItems([..._items]);
    updateTrainingHelpPriority(_items, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };
  
  const getAllTrainingHelps = async (pageBlockId?: number, 
    noOfItems?: number, 
    configUserType?: number) => {
    setLoader(true)
    try{
      await getTraininghelps(pageBlockId, noOfItems, configUserType);
    }
    finally{
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllTrainingHelps(undefined, undefined, ConfigUserTypes.Staff);
    return () => {
      dispatch(setApps([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    trainingHelps && setfilteredItems(cloneDeep(trainingHelps));
  }, [trainingHelps]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Training Help</h2>
        </div>
  
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner/>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: ITrainingHelps) => item.displayOrNot)
                  .map((trainingHelp: ITrainingHelps, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{trainingHelp.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={trainingHelp.displayOrNot}
                            id={trainingHelp.priority + "trainingHelp"}
                            onChange={() => {
                              
                              ChangeVisibleOrNot(
                                trainingHelp.id ?? 0,
                                !trainingHelp.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={trainingHelp.priority + "trainingHelp"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              trainingHelp.image
                                ? baseURL + trainingHelp.image
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <h2>{trainingHelp.name}</h2>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: ITrainingHelps) => !item.displayOrNot)
                .map((trainingHelp: ITrainingHelps, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={trainingHelp.displayOrNot}
                          id={trainingHelp.priority + ""}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              trainingHelp.id ?? 0,
                              !trainingHelp.displayOrNot
                            );
                          }}
                        />
                        <label htmlFor={trainingHelp.priority + ""}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            trainingHelp.image ? baseURL + trainingHelp.image : ""
                          }
                          alt=""
                        />
                      </div>
                      <h2>{trainingHelp.name}</h2>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateTrainingHelpPriority: (data: any, callBack: Function) =>
    updateTrainingHelpPriority(data, callBack),
  getTraininghelps: (pageBlockId?: number, noOfItems?: number, configUserType?: number) =>
    getTrainingHelps(pageBlockId, noOfItems, configUserType),
};

function mapStateToProps(state: any) {
  return {
    trainingHelps: state.trainingHelp?.trainingHelps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityTrainingHelps);
